import { Suspense, useEffect } from 'react';
import * as Sentry from '@sentry/react';
import { DefaultButton, FlexStack, Icon } from '~/components/atomic';
import { Header } from '~/components/common/Header';
import { GetListForCreationData } from '~/types';
import useCreateNewCharacterStore, {
  CreateNewCharacterStates,
} from '~/store/useCreateNewCharacterStore';
import ChatAvatarCanvas from '../Canvas/Canvas';
import CharacterList from './CharacterList/CharacterList';
import * as S from './SelectCharacter.styled';

interface SelectCharacterProps {
  onNextStep: (type: CreateNewCharacterStates['generateType']) => void;
  characterList: GetListForCreationData[];
}

export default function SelectCharacter({
  onNextStep,
  characterList,
}: SelectCharacterProps) {
  const selectedId = useCreateNewCharacterStore((state) => state.preset.id);
  const setPresetState = useCreateNewCharacterStore(
    (state) => state.setPresetState,
  );

  const handleCharacterClick = ({
    id,
    url,
  }: Pick<CreateNewCharacterStates['preset'], 'id' | 'url'>) => {
    setPresetState({
      id,
      url,
    });
  };

  useEffect(() => {
    if (characterList.length > 0) {
      const defaultSelectCharacter = characterList[0];
      setPresetState({
        id: defaultSelectCharacter.avatar_id,
        url: defaultSelectCharacter.file,
      });
    }
  }, []);

  return (
    <>
      <Header.Root>
        <Header.Section>
          <Header.PrevButton />
          <Header.Title>Generate Character</Header.Title>
        </Header.Section>
      </Header.Root>

      <S.Container>
        <S.CanvasWrapper>
          <Sentry.ErrorBoundary fallback={undefined}>
            <Suspense fallback={<div />}>
              <ChatAvatarCanvas />
            </Suspense>
          </Sentry.ErrorBoundary>
        </S.CanvasWrapper>

        <S.TopUploadWrapper>
          {/* <S.TopUploadButton onClick={() => onNextStep('user')}>
            <Icon iconName='Add' />
            Upload
          </S.TopUploadButton> */}
        </S.TopUploadWrapper>

        <S.BottomWrapper>
          <FlexStack direction='row'>
            <S.CharacterUploadCard onClick={() => onNextStep('avaturn')}>
              <S.AiTag>
                <Icon iconName='AI' size={28} />
              </S.AiTag>
              <Icon iconName='Add' />
              Generate Character
            </S.CharacterUploadCard>
          </FlexStack>

          <FlexStack>
            <S.CardTitle>My avatar</S.CardTitle>
            <S.CharacterCardWrapper>
              <Sentry.ErrorBoundary fallback={undefined}>
                <CharacterList
                  characters={characterList}
                  selectedId={selectedId}
                  handleCharacterClick={handleCharacterClick}
                />
              </Sentry.ErrorBoundary>
            </S.CharacterCardWrapper>
          </FlexStack>

          <DefaultButton
            disabled={!selectedId}
            onClick={() => onNextStep('preset')}
          >
            Next <Icon iconName='ArrowRight' />
          </DefaultButton>
        </S.BottomWrapper>
      </S.Container>
    </>
  );
}
